import { AnonymousUploadInitResponse, FileChunk, UploadAnonymousHolterFileV2Options } from "../types";
import { AnonymousHolterUploader } from "./AnonymousHolterUploader";
import { GcsResumableHolterUploader } from "./GcsResumableHolterUploader";
import { MultipartHolterUploader } from "./MultipartHolterUploader";

export const createAnonymousHolterUploader = ({
  initData,
  chunks,
  options,
}: {
  initData: AnonymousUploadInitResponse;
  chunks: FileChunk[];
  options: UploadAnonymousHolterFileV2Options;
}): AnonymousHolterUploader => {
  if (initData.upload_type === "resumable" && initData.service === "gcs") {
    return new GcsResumableHolterUploader({ initData, chunks, options });
  }

  if (initData.upload_type === "multipart" && initData.requires_list_multipart_links) {
    return new MultipartHolterUploader({ initData, chunks, options });
  }

  throw new Error(`Unsupported anonymous Holter upload type: ${initData.upload_type || "unknown"}`);
};
